/* global window, global */
const G = global || window;

const {domains, languages} = require('./data/constants.json');

const locationWithoutLanguagePrefix = location =>
  location.protocol === 'http:' || location.protocol === 'https:' ?
    `${location.protocol}//${domains.wix}${location.pathname}${location.search}` : '';

const setLanguageUrl = language => {
  const redirectTo = locationWithoutLanguagePrefix(G.location);
  return `https://${domains.wixUsers}/wix-users/auth/setLanguage?language=${language}${redirectTo ? `&redirectTo=${redirectTo}` : ''}`;
};

const loginUrl = ({postLogin, postSignUp} = {}) => {
  const getParams = {
    loginDialogContext: 'login',
    referralInfo: 'HEADER',
    postLogin,
    postSignUp
  };
  const getParamsString = Object.keys(getParams)
    .filter(param => getParams[param])
    .map(param => [param, encodeURIComponent(getParams[param])].join('='))
    .join('&');
  return `https://${domains.wix}/signin?${getParamsString}`;
};

const languagesMenu = (list = []) =>
  list.map(language => ({
    text: languages[language],
    href: setLanguageUrl(language)
  }));

const obtainLanguage = () => {
  const subDomain = G.location.host.split('.')[0];
  if (subDomain !== 'www' && subDomain.length === 2) {
    return subDomain;
  }
  const lang = document.cookie.indexOf('wixLanguage=') >= 0 ? document.cookie.substr(document.cookie.indexOf('wixLanguage=') + 12, 2) : 'en';
  return lang;
};

const getValueFromObjectByPrefix = (object, prefix = '') => {
  const objectClosure = Object.assign({}, object);
  return key => objectClosure[`${prefix}${key}`] || key;
};

const linkObjectFromMap = (value, map, forLanguage = 'en') => {
  const get = getValueFromObjectByPrefix(map);
  let [text, href, target, rel, title, important] = value.split(' | ').map(chunk => (chunk || '').trim());
  if (href && href.indexOf('/') === 0 && href.indexOf('//') !== 0) {
    href = `//${forLanguage === 'en' ? domains.wix : `${forLanguage}.${domains.wixNaked}`}${href}`;
  }
  return {
    text: get(text),
    href,
    target,
    rel,
    subs: [],
    title: get(title) || href || text,
    important: !!important
  };
};

const menuFromMap = (map, prefix, translations, forLanguage = 'en', modifiers = []) => { // eslint-disable-line
  const menu = [];
  let index1, index2;
  index1 = 1; while (map[`${prefix}.${index1}`]) {
    let linkObject = linkObjectFromMap(map[`${prefix}.${index1}`], translations, forLanguage);
    index2 = 1; while (map[`${prefix}.${index1}.${index2}`]) {
      linkObject.subs.push(linkObjectFromMap(map[`${prefix}.${index1}.${index2}`], translations, forLanguage));
      index2++;
    }
    modifiers.forEach(modifier => {
      if (linkObject === null) {
        return;
      }
      linkObject = modifier(linkObject, forLanguage);
    });
    if (linkObject !== null) {
      menu.push(linkObject);
    }
    index1++;
  }
  return menu;
};

const createNodeInBody = (tagName = 'div', insertBefore = null, id = null, classNames = []) => {
  const node = document.createElement(tagName);
  if (id) {
    node.setAttribute('id', id);
  }
  if (classNames && classNames.length) {
    node.setAttribute('class', classNames.join(' '));
  }
  document.body.insertBefore(node, insertBefore);
  return node;
};

const getRootNodes = (headerSelector, footerSelector) => {
  const nodes = {
    header: document.querySelector(headerSelector),
    footer: document.querySelector(footerSelector)
  };
  if (!nodes.header) {
    nodes.header = createNodeInBody('nav', document.body.firstChild);
  }
  if (!nodes.footer) {
    nodes.footer = createNodeInBody('footer', null);
  }
  return nodes;
};

const sanitizeRootNodes = (nodes = {}) => {
  const defaults = {
    header: {
      selector: '#wix-menu',
      tag: 'nav',
      place: document.body.firstChild
    },
    footer: {
      selector: '#wix-footer',
      tag: 'footer',
      place: null
    }
  };
  ['header', 'footer'].forEach(part => {
    if (!(nodes[part] instanceof HTMLElement)) {
      const {selector, tag, place} = defaults[part];
      nodes[part] = document.querySelector(selector) || createNodeInBody(tag, place);
    }
  });
};

const mapObject = (object, mapper) => {
  const mappedObject = {};
  Object.keys(object).forEach(key => mappedObject[key] = mapper(object[key], key));
  return mappedObject;
};

const innerHTML = (node, html, className, lang = null) => {
  node.removeAttribute('id');
  if (className) {
    node.setAttribute('class', className);
  }
  if (lang) {
    node.setAttribute('lang', lang);
  }
  node.innerHTML = html || '';
};

const arrayWithoutDublicates = origin =>
  origin.filter((item, position) => origin.indexOf(item) === position);

const getClassesFromString = string =>
  string ? arrayWithoutDublicates(string.split(' ')) : [];

const toggleClass = (node, string, force = null) => {
  const classNames = getClassesFromString(node.className);
  const givenClassNames = getClassesFromString(string);
  givenClassNames.forEach(className => {
    const index = classNames.indexOf(className);
    if ((force === true || force === null) && index < 0) {
      classNames.push(className);
    } else if ((force === false || force === null) && index >= 0) {
      classNames.splice(index, 1);
    }
  });
  node.className = classNames.join(' ');
};

const truncate = (string, length) =>
  string.length <= length ? string : string.slice(0, length) + '…';

const toCamelCase = str =>
  str.toLowerCase()
     .replace(/[-_]+/g, ' ')
     .replace(/[^\w\s]/g, '')
     .replace(/ (.)/g, match => match.toUpperCase())
     .replace(/ /g, '');

const wrapLinkWithBiEvent = (logger, link, evid, extendParams) => {
  const listener = event => {
    event.preventDefault();
    const params = {evid};
    if (extendParams) {
      Object.assign(params, extendParams(link));
    }
    logger.log(params).then(() => window.location.assign(link.href));
  };
  link.addEventListener('click', listener);
  link.addEventListener('tap', listener);
};

const parseURI = string => {
  const link = document.createElement('a');
  link.href = string;
  return link;
};

const enlist = (...args) =>
  args.reduce((result, arg) => result.concat(arg), []);

const ensure = (value, args = []) =>
  value === undefined ? null : value instanceof Function ? value.apply(null, args) : value;

const intersection = (...arrays) =>
  arrays.length === 0 ? [] :
  arrays.length === 1 ? arrayWithoutDublicates(arrays[0]) :
  arrays.length === 2 ? arrayWithoutDublicates(arrays[0]).filter(element => arrays[1].indexOf(element) >= 0) :
  arrays.slice(1).reduce((result, array) => arrayWithoutDublicates(result).filter(element => array.indexOf(element) >= 0), arrays[0]);

const throttle = (fn, threshhold = 250, context = this) => {
  let last, deferTimer;
  return function () {
    const now = Date.now();
    const args = arguments;
    if (last && now < last + threshhold) {
      clearTimeout(deferTimer);
      deferTimer = setTimeout(() => {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
};

const clone = value =>
  value === null ? null :
  typeof value === 'symbol' ? Symbol('cloned') :
  typeof value === 'object' ? JSON.parse(JSON.stringify(value)) :
  typeof value === 'function' ? value.bind({}) :
  value;

const capitalize = value =>
  value.charAt(0).toUpperCase() + value.substr(1);

const warnAndReturn = (message, returnValue, printPromiseErrors = true) => (...errors) => {
  const toPrint = printPromiseErrors ? [message].concat(errors) : [message];
  console.warn(...toPrint);
  return returnValue;
};

const warnAndThen = (...warns) =>
  new Promise(() => console.warn(...warns));

module.exports = {
  setLanguageUrl,
  loginUrl,
  languagesMenu,
  obtainLanguage,
  getValueFromObjectByPrefix,
  menuFromMap,
  getRootNodes,
  sanitizeRootNodes,
  mapObject,
  innerHTML,
  toggleClass,
  truncate,
  toCamelCase,
  wrapLinkWithBiEvent,
  parseURI,
  enlist,
  ensure,
  arrayWithoutDublicates,
  intersection,
  throttle,
  clone,
  capitalize,
  warnAndReturn,
  warnAndThen
};



// WEBPACK FOOTER //
// ./utils.js